var _rect, _path, _path2, _text, _text2, _path3, _circle, _path4, _text3, _text4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestPartners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 370,
    height: 100,
    viewBox: "0 0 370 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 370,
    height: 100,
    rx: 12,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 34 51 20 82 34 51 48Z",
    fill: "#2563eb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 44v17q19 14 38 0V44L51 53Z",
    fill: "#2563eb"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 48,
    fontFamily: "Arial,sans-serif",
    fontSize: 20,
    fontWeight: "bold",
    fill: "#172554"
  }, "EduTest")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 94,
    y: 68,
    fontFamily: "Arial,sans-serif",
    fontSize: 11,
    fill: "#475569"
  }, "APPRENDRE")), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M190 18v64",
    stroke: "#cbd5e1"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 222,
    cy: 45,
    r: 19,
    fill: "#0d9488"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m212 45 7 7 14-15",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 4
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 251,
    y: 48,
    fontFamily: "Arial,sans-serif",
    fontSize: 18,
    fontWeight: "bold",
    fill: "#134e4a"
  }, "Campus")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 251,
    y: 68,
    fontFamily: "Arial,sans-serif",
    fontSize: 11,
    fill: "#475569"
  }, "D\xC9MO")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestPartners);
export default __webpack_public_path__ + "static/media/test-partners.800bddd919ec509727d21084e3e7d203.svg";
export { ForwardRef as ReactComponent };